import { render, staticRenderFns } from "./GatewayCharges.vue?vue&type=template&id=0021db61&scoped=true"
import script from "./GatewayCharges.vue?vue&type=script&lang=js"
export * from "./GatewayCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021db61",
  null
  
)

export default component.exports